import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CasesService } from 'src/app/services/cases/cases.service';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-discard-case-dialog',
  templateUrl: './discard-case-dialog.component.html',
  styleUrls: ['./discard-case-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class DiscardCaseDialogComponent {
  private dialogRef =
    inject<MatDialogRef<DiscardCaseDialogComponent>>(MatDialogRef);
  private data = inject<{
    id: string;
  }>(MAT_DIALOG_DATA);
  private casesService = inject(CasesService);
  private snackbar = inject(MatSnackBar);
  private translate = inject(TranslateService);

  loading = false;

  async submit(): Promise<void> {
    if (this.loading) {
      return;
    }
    try {
      this.loading = true;
      await this.casesService.deleteCase(this.data.id);
      this.dialogRef.close(true);
    } catch (error) {
      console.error(error);
      this.snackbar.open(
        this.translate.instant('ERROR_MESSAGES.UNKNOWN_ERROR'),
        this.translate.instant('OK'),
        {
          duration: 5000,
        },
      );
    } finally {
      this.loading = false;
    }
  }
}
